import { useState } from 'react'
import { Button, ButtonLink, SuccessBlock } from '@/ds'
import { NotAvailable } from '@/app/components/NotAvailable'
import { useLoadedStay } from '@/app/stay/StayProvider'
import { time } from '@/lib/format'
import { checkoutService } from '@/services/checkout'
import type { Checkout } from '@/services/checkout'
import { useSave } from '../Checkin/useSave'
import { useLang } from '../Reserva/shared'
import { leftWhatsappHref } from './shared'

/**
 * "Ya hemos salido" (Cierre.dc.html checkout): un toque para que la propiedad empiece la revisión y libere antes la
 * fianza. Con la API actual no hay endpoint y guardarlo en el dispositivo no avisaría a nadie: WhatsApp con la
 * referencia (D52).
 */
export function LeaveAction({ checkout, help, onLeft }: { checkout: Checkout; help: string; onLeft: (leftAt: string) => void }) {
  const { t, lang } = useLang()
  const stay = useLoadedStay()
  const { saving, error, run } = useSave()
  const [leftAt, setLeftAt] = useState<string | null>(checkout.leftAt)

  if (leftAt) {
    return (
      <SuccessBlock title={t('v2.salida.avisadoTitulo')} headingLevel={2}>
        {t('v2.salida.avisadoTexto', { time: time(leftAt, lang) })}
      </SuccessBlock>
    )
  }
  if (!checkout.canMarkLeft) {
    const whatsapp = stay.contact.whatsapp
    // Sin WhatsApp no hay forma de avisar desde la app: el aviso común con lo que hay que hacer y el teléfono.
    if (!whatsapp) return <NotAvailable consequences={[t('v2.salida.avisarSinWhatsapp')]} />
    return (
      <div className="cierre__stack">
        <ButtonLink icon="message-circle" href={leftWhatsappHref(whatsapp, stay.reference, t)} target="_blank" rel="noreferrer">
          {t('v2.salida.avisarWhatsapp')}
        </ButtonLink>
        <p className="cierre__note">{t('v2.ayuda.whatsappNota', { reference: stay.reference })} {t('v2.salida.avisarWhatsappMotivo')}</p>
      </div>
    )
  }
  const leave = async () => {
    const res = await run(() => checkoutService.markLeft(stay))
    if (res) {
      setLeftAt(res.leftAt)
      onLeft(res.leftAt)
    }
  }
  return (
    <div className="cierre__stack">
      <Button onClick={() => void leave()} loading={saving}>
        {t('v2.salida.yaHemosSalido')}
      </Button>
      {error && (
        <p className="pagos__error" role="alert">
          {error}
        </p>
      )}
      <p className="cierre__note">{help}</p>
    </div>
  )
}
